import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadPartners } from './utils';

export default function* listenLoadPartners() {
  yield takeEvery(homeActions.loadPartners.toString(), loadPartners);
}
